import AILabsPage from "@/components/ai-labs/AILabsPage.vue";
import AIQuestionPage from "@/components/ai-labs/AIQuestionPage.vue";

const ailabsRoutes = [{
    path: '/ai-labs',
    component: AILabsPage,
    meta: {
        requiresAuth: false, // Allow public access to browse AI labs
        title: "AI Labs | Akademi Siber"
    },
},
{
    path: '/ai-labs/:id',
    component: AIQuestionPage,
    meta: {
        requiresAuth: true, // Require auth for accessing specific AI lab
        title: "AI Labs | Akademi Siber"
    },
}
];

export default ailabsRoutes;